module.exports = __webpack_public_path__ + "static/rws-webhook-2230bd2b8ea05dec762097b2b6d703c9.jpg";